export const SITE_URL: string =
  import.meta.env.VITE_SITE_URL || "https://cssbuybr.wiki";

export const SITE_NAME = "CSSBuyBR Wiki";

export const SITE_LOGO =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png";

export const HOME_KEYWORDS =
  "CSSBuy Spreadsheet, CSSBuy Review, CSSBuy Shipping, CSSBuy Warehouse, CSSBuy Coupon, CSSBuy Discount Code, CSSBuy QC, CSSBuy Guide";

export function upsertMeta(
  attr: "name" | "property",
  key: string,
  content: string
) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function removeMeta(attr: "name" | "property", key: string) {
  const el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (el) el.remove();
}

export function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]'
  );
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}